//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    state: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  methods: {}
};